(function () {
  function money(cents, symbol) {
    var amount = Number(cents || 0) / 100;

    return String(symbol || '$') + amount.toLocaleString('en-US', {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function shopifyRoute(path) {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + path.replace(/^\//, '');
    }

    return path;
  }

  function setHeight(root) {
    var footerHeight = 82;
    var rect = root.getBoundingClientRect();
    var currentScrollY = window.scrollY || window.pageYOffset || 0;
    var top = rect.top;

    if (top < 0) {
      top = 0;
    }

    document.documentElement.classList.add('server-configurator-page-lock');
    document.body.classList.add('server-configurator-page-lock');

    if (!document.body.getAttribute('data-configurator-scroll-y')) {
      document.body.setAttribute('data-configurator-scroll-y', String(currentScrollY));
      document.body.style.top = '-' + currentScrollY + 'px';
    }

    root.classList.add('is-viewport-locked');
    root.style.setProperty('--sc-fixed-top', top + 'px');
    root.style.setProperty('--sc-footer-height', footerHeight + 'px');
    root.style.setProperty('--sc-height', 'calc(100vh - ' + top + 'px - ' + footerHeight + 'px)');
  }

  function normalizeRawOptions(raw) {
    if (!raw) {
      return [];
    }

    if (Array.isArray(raw)) {
      return raw
        .map(function (item) {
          return String(item || '').trim();
        })
        .filter(Boolean);
    }

    return String(raw)
      .replace(/\r/g, '')
      .split(/[;\n]+/)
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function parseOption(line) {
    var parts = String(line || '').split('|');

    var name = String(parts[0] || '').trim();
    var priceRaw = String(parts[1] || '').trim().replace(/\$/g, '').replace(/,/g, '');
    var qty = String(parts[2] || '').trim();

    var priceNumber = Number(priceRaw);
    var priceCents = Number.isNaN(priceNumber) ? 0 : Math.round(priceNumber * 100);

    return {
      name: name,
      priceRaw: priceRaw,
      priceCents: priceCents,
      qty: qty
    };
  }

  function optionLabel(option, symbol) {
    var qtyPart = option.qty ? option.qty + 'x ' : '';
    var pricePart = '';

    if (option.priceRaw !== '') {
      pricePart = option.priceCents > 0
        ? ' +' + money(option.priceCents, symbol)
        : ' Included';
    }

    return qtyPart + option.name + pricePart;
  }

  function getConfigData(root) {
    var script = root.querySelector('[data-config-data]');

    if (!script) {
      return { groups: [] };
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return { groups: [] };
    }
  }

  function renderGroups(root) {
    var mount = root.querySelector('[data-config-groups]');
    var emptyNote = root.querySelector('[data-empty-note]');
    var currencySymbol = root.getAttribute('data-currency-symbol') || '$';
    var data = getConfigData(root);
    var html = '';
    var rendered = 0;

    (data.groups || []).forEach(function (group) {
      var rawOptions = normalizeRawOptions(group.raw);
      var options = rawOptions
        .map(parseOption)
        .filter(function (option) {
          return option.name !== '';
        });

      if (!options.length) {
        return;
      }

      rendered += 1;

      html +=
        '<section class="server-configurator__group" data-config-group>' +
          '<div class="server-configurator__group-head">' +
            '<div class="server-configurator__group-number">' + escapeHtml(group.number || '') + '</div>' +
            '<div>' +
              '<h3>' + escapeHtml(group.title || '') + '</h3>' +
              '<p>' + escapeHtml(group.description || '') + '</p>' +
            '</div>' +
          '</div>' +
          '<label class="server-configurator__select-label">' + escapeHtml(group.title || '') + ' Option</label>' +
          '<select class="server-configurator__select" data-config-select data-group-title="' + escapeHtml(group.title || '') + '">';

      options.forEach(function (option, index) {
        html +=
          '<option' +
            ' value="' + escapeHtml(option.name) + '"' +
            ' data-option-title="' + escapeHtml(option.name) + '"' +
            ' data-qty="' + escapeHtml(option.qty) + '"' +
            ' data-price-raw="' + escapeHtml(option.priceRaw) + '"' +
            ' data-price-cents="' + option.priceCents + '"' +
            (index === 0 ? ' selected' : '') +
          '>' +
            escapeHtml(optionLabel(option, currencySymbol)) +
          '</option>';
      });

      html +=
          '</select>' +
        '</section>';
    });

    if (mount) {
      mount.innerHTML = html;
    }

    if (emptyNote) {
      emptyNote.hidden = rendered !== 0;
    }
  }

  function selectedOption(select) {
    return select.options[select.selectedIndex];
  }

  function getNumber(input, fallback) {
    if (!input) {
      return fallback;
    }

    var value = Number(input.value);

    if (Number.isNaN(value)) {
      return fallback;
    }

    return value;
  }

  function getState(root) {
    var mainPriceCents = Number(root.getAttribute('data-main-price-cents') || 0);
    var mainVariantId = root.getAttribute('data-main-variant-id') || '';
    var currencySymbol = root.getAttribute('data-currency-symbol') || '$';
    var systemQty = Math.max(1, getNumber(root.querySelector('[data-system-qty]'), 1));
    var selected = [];
    var addonsCents = 0;

    root.querySelectorAll('[data-config-select]').forEach(function (select) {
      var option = selectedOption(select);

      if (!option) {
        return;
      }

      var priceCents = Number(option.getAttribute('data-price-cents') || 0);

      addonsCents += priceCents;

      selected.push({
        groupTitle: select.getAttribute('data-group-title') || '',
        optionTitle: option.getAttribute('data-option-title') || option.value || '',
        qty: option.getAttribute('data-qty') || '',
        priceCents: priceCents
      });
    });

    var unitTotalCents = mainPriceCents + addonsCents;

    return {
      mainVariantId: mainVariantId,
      mainPriceCents: mainPriceCents,
      currencySymbol: currencySymbol,
      systemQty: systemQty,
      selected: selected,
      unitTotalCents: unitTotalCents,
      totalCents: unitTotalCents * systemQty
    };
  }

  function updatePreview(root, state) {
    var preview = root.querySelector('[data-selection-preview]');

    if (!preview) {
      return;
    }

    preview.innerHTML = state.selected.map(function (item) {
      var text = item.qty ? item.qty + 'x ' + item.optionTitle : item.optionTitle;

      return (
        '<div class="server-configurator__preview-item">' +
          '<span>' + escapeHtml(item.groupTitle) + '</span>' +
          '<p>' + escapeHtml(text) + '</p>' +
        '</div>'
      );
    }).join('');
  }

  function updatePrice(root, state) {
    var price = root.querySelector('[data-config-price]');

    if (price) {
      price.textContent = money(state.totalCents, state.currencySymbol);
    }
  }

  function updateUI(root) {
    var state = getState(root);

    updatePreview(root, state);
    updatePrice(root, state);
  }

  function showMessage(root, text, type) {
    var message = root.querySelector('[data-config-message]');

    if (!message) {
      return;
    }

    message.hidden = false;
    message.className = 'server-configurator__message is-' + type;
    message.textContent = text;
  }

  function clearMessage(root) {
    var message = root.querySelector('[data-config-message]');

    if (!message) {
      return;
    }

    message.hidden = true;
    message.textContent = '';
  }

  function addToCart(root) {
    var state = getState(root);

    if (!state.mainVariantId) {
      showMessage(root, 'Main server product is not selected.', 'error');
      return;
    }

    var properties = {};

    state.selected.forEach(function (item) {
      properties[item.groupTitle] = item.qty
        ? item.qty + 'x ' + item.optionTitle
        : item.optionTitle;
    });

    properties['Configured price estimate'] = money(state.totalCents, state.currencySymbol);

    fetch(shopifyRoute('/cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(state.mainVariantId),
        quantity: state.systemQty,
        properties: properties
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        return response.json();
      })
      .then(function () {
        showMessage(root, 'Configuration added. Redirecting to cart...', 'success');

        window.setTimeout(function () {
          window.location.href = shopifyRoute('/cart');
        }, 500);
      })
      .catch(function () {
        showMessage(root, 'Could not add this configuration to cart.', 'error');
      });
  }

  function bindEvents(root) {
    var form = root.querySelector('[data-configurator-form]');

    root.querySelectorAll('[data-config-select], [data-system-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearMessage(root);
        updateUI(root);
      });

      input.addEventListener('input', function () {
        clearMessage(root);
        updateUI(root);
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        clearMessage(root);
        addToCart(root);
      });
    }
  }

  function setup(root) {
    renderGroups(root);
    bindEvents(root);
    updateUI(root);

    window.setTimeout(function () {
      setHeight(root);
    }, 100);

    window.addEventListener('resize', function () {
      setHeight(root);
    });

    window.addEventListener('load', function () {
      setHeight(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-server-configurator]').forEach(setup);
  });
})();